module.exports = __webpack_public_path__ + "static/img/logo.3288b43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/logo.jpg
// module id = k8qA
// module chunks = 5